<template>
  <div class="pokemon-container">
    
    <img
    v-if="!showPokemon"
    :src="imgSrc"
    class="hidden-pokemon"
    alt="pokemon">
    
    <img 
    v-else
    :src="imgSrc" 
    class="fade-in"
    alt="pokemon">

  </div>

</template>

<script>
export default {
  props: {
    pokemonId: {
      type: Number,
      required: true,
    },
    showPokemon: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  computed: {
    imgSrc() {
      return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${this.pokemonId}.svg`
    }
  }

}
</script>

<style scope>

.pokemon-container {
  width: 250px;
  height: 250px;
  margin: auto;
}

img {
  height: 200px;
  margin-top: 20px;
  user-select: none;
  width: 100px;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
}

.hidden-pokemon {
  filter: brightness(0);
}

</style>